<template>
	<div
		class="wrap-scroll wrap-message-mobile"  id="wrap-scroll-message"
		:style="{ height: windowHeight - 350 + 'px' }"
		:class="messageItem.blocked ? 'bloced-chat' : ''"
	>
		<div class="wrap-scroll-message">
			<infinite-loading @distance="2" direction="top" @infinite="infiniteHandlerMsgDetail" ref="infiniteHandlerMsgDetail">
				<span slot="no-results"></span>
				<span slot="no-more"></span>
			</infinite-loading>
			<template v-for="(item, index) in messageItem.messages">
				<div  :key="index">
					<div class="wrap-message" >
						<div class="date-line" v-if="item.listing">
							<hr class="line-dash" />
							<div
								class="date"
								:class="item.blocked ? 'remove-white-background' : ''"
							>
								{{
									item.created_at
										| formatDate($router.currentRoute.params.lang, true)
								}}
								<ClockOutlineIcon />
								{{ item.created_at | formatHour($router.currentRoute.params.lang) }}
							</div>
						</div>
						<div class="card-message" v-if="item.listing">
							<div class="info-product">
								<div class="img-product">
									<b-avatar
										:size="66"
										class="bg-transparent"
										:src="
											item.listing && item.listing.url_feature_image
												? item.listing.url_feature_image
												: '/images/card1.png'
										"
									></b-avatar>
								</div>
								<div class="info">
									<div class="name-product">
										{{
											item.listing && item.listing.title ? item.listing.title : '--'
										}}
									</div>
									<div class="price">
										{{
											item.listing && item.listing.price
												? item.listing.price.toLocaleString('th-TH')
												: '0'
										}}
										{{ $t('baht') }}
									</div>
								</div>
							</div>
							<div class="message" v-html="item.message">
							</div>
							<div class="contact-user">
								<div class="sender-name">
									<UserIcon />
									{{
										item.user_from && item.user_from.display_name
											? item.user_from.display_name
											: item.user_from.email
									}}
								</div>
								<div class="type-contact">
									<div class="box-seller box-phone">
										<a
											:href="
												`tel:${
													item.user_from && item.user_from.telephone
														? item.user_from.telephone
														: ''
												}`
											"
										>
											<IconPhone />
										</a>
									</div>
									<div class="box-seller box-mail">
										<a
											:href="
												`mailto:${
													item.user_from && item.user_from.email
														? item.user_from.email
														: item.user_from.display_name
												}`
											"
										>
											<IconMail />
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="user-messsage-chat" v-if="!item.listing">
							<span
								class="message-date"
								:class="
									item.user_from.current_user == 1
										? 'sender-message-date'
										: 'receiver-message-date'
								"
							>
								<div v-if="item.seen">
									<IconCheck />
									<span style="margin-left:5px;">{{ $t('userDashboard.messages.read') }}</span>
								</div>
								{{
									item.created_at
										| formatDate($router.currentRoute.params.lang, true)
								}}
								{{ item.created_at | formatHour($router.currentRoute.params.lang) }}
							</span>
							<div
								:class="
									item.user_from.current_user == 1
										? 'sender-message'
										: 'receiver-message'
								"
								v-if="item.type != 'ATTACHMENTS'"
							>
								<span class="" v-if="item.type == 'MESSAGE'" v-html="item.message"></span>
								<span
									class="location"
									v-if="item.type == 'LOCATION'"
									@click="goToGoogleMap(item)"
									><IconMapPin
								/></span>
							</div>
							<template v-if="item.type == 'ATTACHMENTS'">
								<div
									class="message-attachment"
									:class="
										item.user_from.current_user == 1
											? 'sender-message-image'
											: 'receiver-message-image'
									"
									v-for="(media, index) in item.chat_message_media"
									:key="index"
								>
									<a
										class="file-a"
										:download="item.message.name"
										:href="media.url_media"
										target="_blank"
										v-if="getExtention(media) == 'other'"
									>
										<IconFile />
									</a>
									<a
										:download="item.message.name"
										:href="media.url_media"
										target="_blank"
										v-if="getExtention(media) == 'image'"
									>
										<div
											class="message-image"
											:style="{
												backgroundImage: 'url(' + media.url_media + ')'
											}"
											:id="index"
											:class="
												item.user_from.current_user == 1
													? 'sender-message-image'
													: 'receiver-message-image'
											"
										></div>
									</a>
									<a
										:download="item.message.name"
										:href="media.url_media"
										target="_blank"
										v-if="getExtention(media) == 'video'"
									>
										<video
											width="320"
											height="240"
											controls
											id="media-video"
											autostart="false"
										>
											<source :src="media.url_media" />
											{{ $t('userDashboard.messages.videoNotSupported') }}
										</video>
									</a>
								</div>
							</template>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
import ClockOutlineIcon from 'vue-material-design-icons/ClockOutline.vue';
import UserIcon from 'vue-material-design-icons/AccountOutline.vue';
import IconMail from '../../components/icons/IconMail/index';
import IconPhone from '../../components/icons/IconPhone/index';
import moment from 'moment';
import InfiniteLoading from 'vue-infinite-loading';
import IconMapPin from '@/components/icons/IconMapPin/index';
import IconFile from '@/components/icons/IconFile/index';
import IconCheck from '@/components/icons/IconCheck/index';

export default {
	components: {
		ClockOutlineIcon,
		UserIcon,
		IconMail,
		IconPhone,
		InfiniteLoading,
		IconMapPin,
		IconFile,
		IconCheck
	},
	data() {
		return {
			// windowHeight: window.innerHeight - 220
		};
	},
	props: {
		messageItem: {
			type: Object,
			default: () => {}
		},
		infiniteHandlerMsgDetail: {
			type: Function,
			default: () => {}
		},
		goToGoogleMap: {
			type: Function,
			default: () => {}
		},
		getExtention: {
			type: Function,
			default: () => {}
		},
		windowHeight: {
			type: Number,
			default: 0
		},  
	},
	filters: {
		formatDate(value, lang) {
			if (!value) return;
			let now = moment(new Date());
			let newVal = moment(value);
			if (now.isSame(newVal, 'day')) return;
			return moment(value)
				.local('th')
				.format('DD MMM YYYY');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.local('th')
				.format('HH:mm');
		}
	},
	// methods: {
	// 	onResize() {
	// 		this.windowHeight = parseInt(document.documentElement.clientHeight);
	// 		this.$forceUpdate();
	// 	}
	// },
	// created() {
	// 	this.onResize();
	// },
	// mounted() {
	// 	this.$nextTick(() => {
	// 		window.addEventListener('resize', this.onResize);
	// 		this.onResize();
	// 	});
	// },
	// beforeDestroy() {
	// 	window.removeEventListener('resize', this.onResize);
	// }
};
</script>
<style lang="scss">
@import 'style';
</style>
